/* eslint-disable max-len */
import { print as dymoPrint } from 'vendor/dymo'
import { print as zebraPrint } from 'vendor/zebra'
import Raven from 'raven-js'

/** Should be `'zebra'|'dymo'` */
const defaultLabelPrinter = window.DEFAULT_PRINTER || 'zebra'

export const reportsList = {
  'packlists': 'paper',
  'shellfishpicklists': 'paper',
  'shellfishsaleslogs': 'paper',
  'smallfishpicklists': 'paper',
  'labels': defaultLabelPrinter
}

export default async ({ orders, reports }) => {
  let success = {}
  let methods = []

  if (reports && reports.length) {
    for (let name in reportsList) {
      let type = reportsList[name]
      if (type && !methods.includes(type) && reports.includes(name)) methods.push(type)
    }
  } else {
    methods = [defaultLabelPrinter, 'paper']
  }

  Raven.captureBreadcrumb({
    message: 'Starting to print.',
    category: 'print',
    data: {
      orders: orders.map(o => o.id),
      reports,
      methods
    }
  })

  if (methods.includes('paper')) {
    try {
      window.print()
      success.paper = true
    } catch (e) {
      success.paper = false
    }
  }

  if (methods.includes('dymo')) {
    try {
      await dymoPrint(orders)
      success.dymo = true
    } catch (e) {
      success.dymo = false
    }
  }

  if (methods.includes('zebra')) {
    try {
      await zebraPrint(orders)
      success.zebra = true
    } catch (e) {
      success.zebra = false
    }
  }

  success.result = methods.reduce((acc, method) => {
    if (success[method] === false) return false
    return acc
  }, true)

  if (!success.result) {
    Raven.captureException(new Error('Printing was unsucessful!'), {
      extra: {
        orders: orders.map(o => o.id),
        reports,
        methods,
        success
      }
    })
  }

  return success.result
}



// WEBPACK FOOTER //
// ./src/helpers/print.js